export default __webpack_public_path__ + "static/media/peep-32.98245b74.svg";